module.exports = __webpack_public_path__ + "static/item--rug@3x.d6ed88fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/item--rug@3x.png
// module id = 660
// module chunks = 126511778744290